// extracted by mini-css-extract-plugin
module.exports = {"productListContainer":"ProductList_productListContainer__6EbO1","productList":"ProductList_productList__2DEVB"};